const BODIES = {
  wisp: 'M110 24 146 64 157 107 138 130 150 167 116 155 91 182 92 145 66 133 55 98 72 63Z',
  wing: 'M104 64 68 27 16 43 37 93 17 131 78 126 97 151 110 177 123 151 143 126 204 131 183 93 204 43 152 27 116 64Z',
  maw: 'M46 61 77 30 145 30 177 61 187 145 160 170 60 170 34 144Z M42 88 178 88 163 118 147 95 130 122 111 95 92 122 74 95 56 118Z',
  hound:
    'M37 90 54 48 83 60 113 38 152 57 190 46 175 85 152 102 149 151 135 173 118 146 107 123 82 118 67 160 49 170 48 122 27 112Z',
  sentry:
    'M71 26 149 26 167 64 151 95 174 112 184 159 155 148 142 179 120 149 100 149 78 179 65 148 36 159 46 112 69 95 53 64Z',
  serpent:
    'M48 51 84 29 143 41 168 79 144 107 86 105 69 128 93 151 142 138 182 147 159 177 82 183 42 153 38 113 74 78 117 80 128 68 99 55 69 72Z',
  spider: 'M84 64 110 37 137 64 149 115 128 151 91 151 71 115Z',
  reaper:
    'M110 24 143 56 154 95 178 168 132 154 110 185 88 154 42 168 66 95 77 56Z',
  knight:
    'M84 25 136 25 156 55 146 85 168 103 161 144 142 153 133 181 113 159 94 181 79 152 58 143 52 103 74 85 64 55Z',
  warden:
    'M59 22 88 45 110 13 132 45 161 22 166 74 187 100 178 151 151 141 144 185 116 161 110 187 104 161 76 185 69 141 42 151 33 100 54 74Z',
};
const LIMBS = {
  wing: 'M37 49 81 89 33 119 M183 49 139 89 187 119 M110 147 110 173',
  maw: 'M47 137 173 137 M63 150 76 150 M145 150 158 150',
  hound: 'M31 105 12 84 31 73 M168 62 178 75 M69 118 84 89',
  sentry: 'M54 66 34 88 21 128 M166 66 186 88 199 128 M76 44 144 44',
  serpent: 'M154 166 173 181 M56 137 70 146 M89 43 81 64',
  spider:
    'M81 77 43 48 18 79 M76 99 34 89 8 119 M80 123 41 142 29 180 M139 77 177 48 202 79 M144 99 186 89 212 119 M140 123 179 142 191 180',
  reaper:
    'M69 90 33 108 18 53 Q67 17 92 44 M33 108 44 185 M151 90 180 111 195 84',
  knight:
    'M61 96 29 89 25 153 53 169 70 141 M157 97 185 61 193 68 164 134 M110 26 110 62',
  warden:
    'M52 91 15 74 9 140 32 158 53 126 M168 91 205 74 211 140 188 158 167 126 M65 31 46 12 M155 31 174 12',
  wisp: 'M73 59 45 42 M147 59 175 42 M73 135 51 154 M149 135 169 154',
};

const FACETS = {
  wisp: 'M110 24 110 74 72 63Z M146 64 157 107 131 100Z M92 145 116 155 91 182Z',
  wing: 'M16 43 81 89 68 27Z M37 93 78 126 17 131Z M204 43 139 89 152 27Z M183 93 143 126 204 131Z M110 111 123 151 110 177Z',
  maw: 'M46 61 77 30 145 30 160 55Z M34 144 60 170 60 132Z M160 132 160 170 187 145Z',
  hound:
    'M54 48 83 60 37 90Z M113 38 152 57 129 80 83 60Z M149 151 135 173 118 146 128 118Z',
  sentry:
    'M71 26 149 26 136 52 84 52Z M53 64 69 95 91 75Z M167 64 151 95 129 75Z M46 112 65 148 36 159Z M174 112 155 148 184 159Z',
  serpent:
    'M48 51 84 29 99 55 69 72Z M143 41 168 79 144 107 139 78Z M42 153 82 183 93 151 69 128Z',
  spider:
    'M84 64 110 37 110 77Z M137 64 149 115 132 108Z M91 151 128 151 110 129Z',
  reaper:
    'M110 24 110 70 77 56Z M66 95 88 154 42 168Z M154 95 178 168 132 154Z',
  knight:
    'M84 25 136 25 144 48 110 60 76 48Z M52 103 79 113 79 152 58 143Z M168 103 142 113 142 153 161 144Z',
  warden:
    'M59 22 88 45 110 13 110 67 78 73Z M110 13 132 45 161 22 143 73 110 67Z M33 100 69 112 69 141 42 151Z M187 100 151 112 151 141 178 151Z M76 185 104 161 90 138Z M144 185 116 161 130 138Z',
};

const SectorEnemyArt = ({ enemy, className = '' }) => (
  <svg
    className={'coreboundEnemyArt ' + className}
    viewBox="0 0 220 200"
    aria-hidden="true"
    focusable="false"
    style={{ '--enemy-color': enemy.color }}
    data-enemy-shape={enemy.shape}
  >
    <ellipse
      className="coreboundEnemyShadow"
      cx="110"
      cy="185"
      rx="69"
      ry="9"
    />
    <g className="coreboundEnemyLimbs">
      <path d={LIMBS[enemy.shape] || LIMBS.sentry} />
    </g>
    <g className="coreboundEnemyBody">
      <path
        className="coreboundEnemyShell"
        d={BODIES[enemy.shape] || BODIES.warden}
        fillRule="evenodd"
      />
      <path
        className="coreboundEnemyFacets"
        d={FACETS[enemy.shape] || FACETS.warden}
      />
      <path
        className="coreboundEnemyCracks"
        d="M110 43 99 62 116 74 104 95 M72 124 94 113 M146 125 127 110 M110 135 116 154"
      />
      <path
        className="coreboundEnemyHeart"
        d="M110 77 133 100 110 130 87 100Z"
      />
      <path className="coreboundEnemyEye" d="M91 95 110 87 129 95 110 106Z" />
      <path className="coreboundEnemyPupil" d="M108 90H112V103H108Z" />
    </g>
    <g className="coreboundEnemySparks">
      <path d="M39 44 45 38 51 44 45 50Z M170 153 177 146 184 153 177 160Z M163 27 168 22 173 27 168 32Z" />
    </g>
  </svg>
);

export default SectorEnemyArt;
